import React, { useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '@/AdminComponent/AddVideoForm/components/Stepper.css';
import videoApi from '@/api/videoApi';
import Stepper, { Step } from '@/AdminComponent/AddVideoForm/components/Stepper';
import { TAGS } from '@/constants/tagsVideos';
import Toast from '@/utils/toastManager';
import { formReducer, initialState } from '@/redux/formData';
import AddVideoDetails from '@/AdminComponent/AddVideoForm/Steps/AddVideoDetails';
import { buildRoutes } from '@/service/buildRoutes';

const AddVideosMux = () => {
	const navigate = useNavigate();
	const [formData, dispatch] = useReducer(formReducer, initialState);

	const handleSubmit = async () => {
		if (!formData.muxVideoLink && !formData.muxUploadId) {
			Toast.error('Please upload a video first');
			return;
		}

		const updatedFormData = {
			...formData,
			tags: Array.isArray(formData.tags) ? [...formData.tags] : []
		};

		if (formData.isClass && !updatedFormData.tags.includes(TAGS.CLASSES)) {
			updatedFormData.tags.push(TAGS.CLASSES);
		}
		if (formData.isClass && new Date(updatedFormData.releaseDateTime) > new Date()) {
			updatedFormData.tags.push(TAGS.COMING_SOON);
		}
		const payload = {
			formData: updatedFormData
		};

		try {
			const response = await videoApi.uploadVideo(payload);

			if (response?.status === 200) {
				Toast.success('Video Successfully Uploaded!');
				navigate(buildRoutes.toAdminAllVideos());
			} else {
				throw new Error('Upload failed');
			}
		} catch {
			Toast.error('Upload Failed, please try again.');
		}
	};

	return (
		<div>
			<Stepper
				initialStep={1}
				onFinalStepCompleted={handleSubmit}
				backButtonText="Previous"
				nextButtonText="Next"
				isStepValid={stepIndex => {
					if (stepIndex === 1) {
						const hasLink = (typeof formData.muxVideoLink === 'string' && formData.muxVideoLink.trim() !== '') || formData.muxUploadId;
						const hasLevel = Array.isArray(formData.videoLevel)
							? formData.videoLevel.length > 0
							: Boolean(formData.videoLevel);
						return hasLink && hasLevel;
					}

					return true;
				}}
			>
				<Step>
					<AddVideoDetails formData={formData} dispatch={dispatch} />
				</Step>
			</Stepper>
		</div>
	);
};

export default AddVideosMux;
